const Home = () => (
    <div>
        <h1>Lista de Musicas</h1>
    </div>
);
export default Home;